import React from "react";
import TextInput from './TextInput'
import TimeInput from './TimeInput'
import TextNumberInput from './TextNumberInput'
import SelectInput from './SelectInput'
import FixButton from './Button'
import AddMeetingService from '../services/addMeeting';
import GetEventService from '../services/getEvent';
import Cookies from 'universal-cookie';
import AddBreak from "../services/addBreak";
import Utils from '../utils/utils';
import getIntermediaries from "../services/getIntermediaries";

export default class InsertMeetingWidget extends React.Component {

    constructor (props){
        super(props);

        this.selectRef = React.createRef();
        this.selectBrokerRef = React.createRef();
        this.selectBreakRef = React.createRef();
        this.subjectsRepresentative = [];
        this.valueRepresentative = [];
        
        this.subjects = [];
        this.state = {
            visible: false,
            selected: 'meeting',
            time: this.props.time
        }
    }

    async componentDidMount(){

        const cookies = new Cookies();
        const username = cookies.get('username', { path: '/' });
        const token = cookies.get('token', { path: '/' });
        const eventId = cookies.get('currentEventId', { path: '/' });

        if (this.props.subjectId == undefined) return;
        let scheduleType = this.props.scheduleType;
        this.subjects = [];
        
        this.brokersCompany = await getIntermediaries(username, token, eventId, 'company');
        this.brokersInvestor = await getIntermediaries(username, token, eventId, 'investor');

        if (scheduleType == 'investor'){
            this.optionsLabel = "Companies";
            this.props.companies.map(company => {
                var brokers = company.broker_id.split(',');
                this.brokersCompany.forEach(b => {
                    if (brokers.includes(b.id) == false) return;
                    this.subjects.push({broker: b.id, value: company.id, label: company.company + ' - ' + company.name + ' (Hosted by ' + b.name + ')'})
                });
            });


        }


        if (scheduleType == 'company'){
            this.currentCompany = undefined;
            this.props.companies.map(c => {
                if (c.id == this.props.subjectId)
                    this.currentCompany = c;
            })

            this.optionsLabel = "Investors";
            this.props.investors.map(investor => {
                var brokers = investor.brokerId.split(',');
                this.brokersInvestor.forEach(b => {
                    if (brokers.includes(b.id) == false) return;
                    this.subjects.push({broker: b.id, value: investor.id, label: investor.company + ' - ' + investor.name + ' (Hosted by ' + b.name + ')'})
                });
            });


            this.currentCompany.rapresentative.split(';').map(r => {
                this.subjectsRepresentative.push({value: r, label: r});
                this.valueRepresentative.push({value: r, label: r});
            });

            this.brokersSelectOptions = [];
            this.brokerSelected = [];

            var companyBrokers = this.currentCompany.broker_id.split(',');
            this.brokersCompany && this.brokersCompany.forEach(b => {
                if (companyBrokers.includes(b.id) == true)
                    this.brokersSelectOptions.push({ value: b.id, label: b.name });
            })
            if (companyBrokers.length == 1)
                this.brokerSelected = { value: companyBrokers[0]}

        }
        else if (scheduleType == 'investor'){

            this.props.investors.map(i => {
                if (i.id == this.props.subjectId)
                    this.currentInvestor = i;
            })

            this.brokersSelectOptions = [];
            this.brokerSelected = [];
            this.brokersInvestor && this.brokersInvestor.forEach(b => {
                if (this.currentInvestor.brokerId.split(',').includes(b.id) == true)
                  this.brokersSelectOptions.push({ value: b.id, label: b.name });
            })
        }

        this.event = await GetEventService(username, token, eventId);

        this.breaksType = [
            {value: 1, label: 'Lunch break'}, 
            {value: 2, label: 'Coffee break'},
            {value: 3, label: 'Unavailable'}
        ];

        this.event.customBreaks.split(';').map(b => {
            this.breaksType.push({value: this.breaksType.length + 1, label: b});
        })

        this.setState({
            visible: this.props.visible,
            scheduleType: scheduleType,
            slots: this.event.slotDuration,
            valueRepresentative: this.valueRepresentative,
            brokers: this.brokerSelected

//            slots: 9
        });
    }

    render (){

        let st = Object.assign({display: this.state.visible ? 'block' : 'none'}, mainClass)

        return ( 
        <div style={st} >
            <div style={closeIcon} onClick={() => {
                this.setState({visible: false});
                this.props.onDone();
            }}>X</div>
            <div style={menu}>
                <div style={Object.assign({background: this.state.selected == 'meeting' ? '#dddddd' : '#ffffff'}, menuVoice)}
                    onClick={() => {this.setState({selected: 'meeting'})}}>
                    Meeting
                </div> 
                <div style={Object.assign({background: this.state.selected == 'break' ? '#dddddd' : '#ffffff'}, menuVoice)}
                    onClick={() => {this.setState({selected: 'break'})}}>
                    Break
                </div> 
            </div>
            <div style={{marginTop: '10px', display: this.state.selected == 'meeting' ? 'block' : 'none'}}>
                <div className="windowTitle">Insert meeting</div>

                { this.state.scheduleType == 'company' ?
                    <SelectInput 
                        ref={this.selectRef}
                        value={this.state.valueRepresentative} 
                        name="Representative" 
                        hidable={true}
                        options={this.subjectsRepresentative} 
                        isMulti={true}
                        onChange={(option) => 
                            this.setState({valueRepresentative: option})} 
                        />
                 : null }

                <TextInput readOnly={true} name={"Date"} value={this.props.date} />
                <TimeInput autoFocus readOnly={true} name={"Time"} value={this.state.time} onChange={(val) => this.setState({time: val}) }/>

                <TextNumberInput name={"Slot duration"} value={this.state.slots * 5} onChange={(val) => 
                    this.setState({slots : val / 5,
                                    value: this.state.value})}/>

                <TextInput readOnly={true} name={this.optionsLabel == "Companies" ? "Investor" : "Company"} value={this.props.subjectName} />

 
                { this.brokersSelectOptions && this.brokersSelectOptions.length > 1 && <SelectInput key={Math.random()} 
                    ref={this.selectBrokerRef}
                    value={this.state.brokers} 
                    name={"Brokers"} 
                    options={this.brokersSelectOptions} 
                    isMulti={false}
                    onChange={(option) => {
                        this.setState({brokers: option});
                      }}
                    />
                    }

                <SelectInput key={Math.random()} 
                    ref={this.selectRef}
                    value={this.state.value} 
                    name={this.optionsLabel} 
                    options={this.subjects} 
                    isMulti={this.props.scheduleType == 'company'}
                    onChange={(option) => 
                        this.setState({value: option})} 
                    />

                <FixButton title={'Save'} callback={this.saveMeeting.bind(this)} />
            </div>
            <div style={{marginTop: '10px', display: this.state.selected == 'break' ? 'block' : 'none'}}>
                <div className="windowTitle">Insert break</div>

                <TextInput readOnly={true} name={"Date"} value={this.props.date} />
                <TimeInput autoFocus readOnly={true} name={"Time"} value={this.state.time} onChange={(val) => this.setState({time: val}) }/>

                <SelectInput key={Math.random()} 
                    ref={this.selectBreakRef}
                    value={this.state.breakType} 
                    name={"Break type"} 
                    options={this.breaksType} 
                    onChange={(option) => 
                        this.setState({breakType: option})} 
                    />
                <TextNumberInput name={"Slot duration"} value={this.state.slots * 5} onChange={(val) => 
                    this.setState({slots : val / 5,
                                    value: this.state.value})}/>
                <FixButton title={'Save'} callback={this.saveBreak.bind(this)} />
            </div>
        </div>
        )
    }

    async saveBreak(){

        var selectedValues = this.selectBreakRef.current.getValue();
        if (selectedValues == undefined || selectedValues.length <= 0) return;

        const cookies = new Cookies();
        const username = cookies.get('username', { path: '/' });
        const token = cookies.get('token', { path: '/' });
        const eventId = cookies.get('currentEventId', { path: '/' });
        const slots = this.state.slots;

        let hh = this.state.time.split(':')[0];
        let mm = this.state.time.split(':')[1];

        if (Utils.checkBreakPossible(this.props.meetings, this.props.breaks, this.props.scheduleType, this.props.subjectId, this.props.date, hh, mm, slots) == false){
            return;
        }

        let asd = await AddBreak(username, token, eventId, this.props.date, hh, mm, this.state.slots, this.props.scheduleType, this.props.subjectId, selectedValues[0].label);
        this.props.onDone();
    }


    checkInvestor(investors, id){
        investors.map(v => {
            if (v.id == id) return true;
        });
        return false;
    }

    async saveMeeting(){

        var selectedValues = this.selectRef.current.getValue();
        if (selectedValues == undefined || selectedValues.length <= 0) return;

        var investorIds = [];
        var selectedIds = [];
        var investorBrokersIds = [];
        var companyBroker = '';
        var investorBroker = '';

        selectedValues.forEach(v => {
            if (v == undefined) return;
            selectedIds.push(v.value);
            investorBrokersIds.push(v.broker);
        });

        if (selectedIds == undefined || selectedIds.length <= 0) return;

        if (this.brokersSelectOptions.length > 1 && this.state.brokers.length <= 0) {
            alert ('Please check the broker for the meeting');
            return;
        }

        const cookies = new Cookies();
        const username = cookies.get('username', { path: '/' });
        const token = cookies.get('token', { path: '/' });
        const eventId = cookies.get('currentEventId', { path: '/' });
        const notes = '';
        const notesRaw = '';

        var companyId = '';
        var investorId = '';
        const date = this.props.date;
        const hour = this.state.time.split(':')[0];
        const minutes = this.state.time.split(':')[1];
        const slots = this.state.slots;

        if (this.props.scheduleType == 'investor'){
            investorIds = [this.props.subjectId];
            if (this.brokersSelectOptions.length > 1){
                var selectedBrokerValues = this.selectBrokerRef.current.getValue();
                investorBroker = selectedBrokerValues[0].value;
            }
            else {
                investorBroker = this.brokersSelectOptions[0].value;
            }
            companyId = selectedIds[0];
            companyBroker = selectedValues[0].broker;            
        }
        if (this.props.scheduleType == 'company'){
            companyId = this.props.subjectId;
            investorIds = selectedIds;
        }

        if (Utils.checkMeetingPossible(this.props.meetings, this.props.breaks, this.props.scheduleType, companyId, investorIds, date, hour, minutes, slots, null) == false) return;

        var res = '';
        if (this.props.scheduleType == 'company')
            res = await AddMeetingService(username, token, eventId, companyId, this.state.brokers.value, investorIds, investorBrokersIds, date, hour, minutes, slots, notes, notesRaw);
        else if (this.props.scheduleType == 'investor')
            res = await AddMeetingService(username, token, eventId, companyId, companyBroker, investorIds, [investorBroker], date, hour, minutes, slots, notes, notesRaw);

        this.props.onDone();
    }

    handleChangeMultiple = (event) => {
        const { options } = event.target;
        const value = [];
        for (let i = 0, l = options.length; i < l; i += 1) {
          if (options[i].selected) {
            value.push(options[i].value);
          }
        }
        this.setState({value: value})
      };

}


const menu = {
    position: 'relative',
    top: '10px',
    display: 'flex',
};

const menuVoice = {
    width: '50%',
    textAlign: 'center',
    border: '1px solid black',
    cursor: 'pointer'
}

const closeIcon = {
    position: 'absolute', 
    cursor: 'pointer',
    right: 0, 
    top: 0, 
    padding: 10
}

const mainClass = {
    position: 'fixed',
    left: '35%',
    top: '10%',
    background: '#ffffff',
    border: '1px solid black',
    padding: '20px',
    overflow: 'scroll',
    height: '600px',
    zIndex: 999
}

const name = {
    
}

const inputText = {
    width: '300px',
    padding: '10px'
}


const inputTextDisabled = {
    background: '#eeeeee',
    width: '300px',
    padding: '10px'
}